export default "__VITE_ASSET__Bi2lWP5T__"